import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from "@mui/material"
import type { FC } from "react"
import { useNewsletterStore } from "../store/newsletterStore"

interface Props {
  open: boolean
  offerId: string | null
  onClose: () => void
}

const EditOfferDialog: FC<Props> = ({ open, offerId, onClose }) => {
  const selected = useNewsletterStore((s) => s.selected)
  const updateSelected = useNewsletterStore((s) => s.updateSelected)

  const offer = selected.find((o) => o.CustomOfferID === offerId)

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Editar oferta</DialogTitle>
      <DialogContent>
        {!offer ? (
          <div className="py-4 text-sm text-gray-600">
            Selecione a oferta antes de editar.
          </div>
        ) : (
          <Stack gap={2} sx={{ mt: 1 }}>
            <TextField
              label="Título"
              value={offer.OfferTitle ?? ""}
              onChange={(e) =>
                updateSelected(offer.CustomOfferID, {
                  OfferTitle: e.target.value,
                })
              }
              fullWidth
            />
            <TextField
              label="Alojamento"
              value={offer.AccommodationName ?? ""}
              onChange={(e) =>
                updateSelected(offer.CustomOfferID, {
                  AccommodationName: e.target.value,
                })
              }
              fullWidth
            />
            <TextField
              label="Preço (texto)"
              value={(offer.LeadInPrice as string) ?? ""}
              onChange={(e) =>
                updateSelected(offer.CustomOfferID, {
                  LeadInPrice: e.target
                    .value as unknown as typeof offer.LeadInPrice,
                })
              }
              fullWidth
            />
            <TextField
              label="Imagem (URL)"
              value={offer.ImageURL ?? ""}
              onChange={(e) =>
                updateSelected(offer.CustomOfferID, {
                  ImageURL: e.target.value,
                })
              }
              fullWidth
            />
            <TextField
              label="Link (URL)"
              value={offer.URL ?? ""}
              onChange={(e) =>
                updateSelected(offer.CustomOfferID, { URL: e.target.value })
              }
              fullWidth
            />
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Fechar</Button>
      </DialogActions>
    </Dialog>
  )
}

export default EditOfferDialog
